<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2024-03-04 15:36:17
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-03-13 14:43:40
 * @FilePath: /chaoyongtuan/src/views/settings/tagManage/components/editTag.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<el-dialog :visible.sync="visible" title="编辑标签" width="540px" :before-close="handleClose" :close-on-click-modal="false">
		<!-- {{ row }} -->
		<p class="yx-color-text-primary pt-16 pb-8 font-h4-medium ml-12">
			该标签下，共
			<span class="yx-color-primary">{{ row.materialTagNum }}</span>
			个素材
		</p>
		<el-form :model="form" label-width="80px" class="pt-16">
			<el-form-item label="标签名称" prop="tagName">
				<el-input v-model="form.tagName" placeholder="请输入（10字以内）" maxlength="10" show-word-limit />
			</el-form-item>
		</el-form>
		<div class="footer-dialog" slot="footer">
			<el-button @click="handleClose">取 消</el-button>
			<el-button type="primary" @click="submit" :disabled="isDisabled">确 认</el-button>
		</div>
	</el-dialog>
</template>
<script>
import { saveOrUpdateTag } from '@/api/tagManagement';
export default {
	computed: {
		isDisabled() {
			return !this.form.tagName;
		},
	},
	data() {
		return {
			visible: false,
			row: {},
			form: {
				tagName: '',
			},
			tagType: 1, //标签类型,
			appType: 1, // 所属应用
		};
	},
	methods: {
		show(row) {
			this.row = row;
			this.form.tagName = row.tagName || '';
			this.visible = true;
		},
		async submit() {
			const {
				form: { tagName },
				row: { id },
				tagType,
				appType
			} = this;
			await saveOrUpdateTag({  tagsList:[{id,tagName,tagType, appType }] });
			this.$message.success('操作成功');
			this.$emit('refreshList');
			this.handleClose();
		},
		handleClose() {
			this.form = {
				tagName: '',
			};
			this.visible = false;
		},
	},
};
</script>
<style lang="scss" scoped></style>
